<template>
  <article :class="['review-card', reviewItemStyles]">
    <div class="review-card__score">
      <img :src="cardBg === 'white' ? AvatarIconBlue : AvatarIconWhite" alt="An icon of an avatar head" />
    </div>
    <div class="review-card__content">
      <p class="review-card__reviewed-by" v-text="reviewedByText" />
      <p class="review-card__published">Published on {{ formattedReviewDate }}</p>

      <div v-if="cardBg === 'transparent'">
        <RouterLink
          :to="{ name: RoutesEnum.EXP_REVIEWS, params: { id: expertReviewData.Vehicle_UID } }"
          v-if="isRACQReview"
          class="mobility-club-link racq-club-review"
          >{{ reviewProvidedByText }}</RouterLink
        >

        <a
          :href="expertReviewData.RelatedLinks.OriginalContentLocation"
          v-else-if="externalReviewLink && externalReviewLink !== 'null'"
          class="button-as-link mobility-club-link"
          v-text="reviewProvidedByText"
        />

        <span v-else class="mobility-club-link" v-text="reviewProvidedByText" />
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router';
import { computed } from 'vue';
import AvatarIconBlue from '@/assets/img/avatar-pale-blue.svg';
import AvatarIconWhite from '@/assets/img/avatar-white.svg';
import { RoutesEnum } from '../../foundation/routeMappings';

const props = defineProps({
  expertReviewData: {
    type: Object,
    default: () => ({}),
  },
  apiStatus: {
    type: String,
    default: 'LOADING',
  },
  cardBg: {
    type: String,
    default: 'white',
  },
  mobilityClubLink: {
    type: String,
    required: false,
  },
});

const reviewItemStyles = computed(() => [props.apiStatus === 'LOADING' ? 'skeleton-box' : `${props.cardBg}-card`]);
const formattedReviewDate = computed(() =>
  new Date(props.expertReviewData.DateOfCarReview ?? '').toLocaleDateString('en-GB', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
);

const isRACQReview = computed(() => props.expertReviewData.MobilityClub === 'RACQ');
const reviewedByText = computed(() => `Reviewed by a motoring journalist at ${props.expertReviewData.MobilityClub}`);
const externalReviewLink = computed(() => props.expertReviewData.RelatedLinks?.OriginalContentLocation);
const reviewProvidedByText = computed(() => `Review provided by ${props.expertReviewData.MobilityClub}`);
</script>

<style lang="scss" scoped>
.review-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;

  &__published {
    margin: 0;
    padding-bottom: 0;
    font-size: 0.85rem;
    line-height: 1.25;

    @media screen and (min-width: #{$breakpoint-md}) {
      font-size: 1rem;
    }
  }

  &__reviewed-by {
    line-height: 1;
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
    margin-top: 0;
    font-weight: bold;

    @media screen and (min-width: #{$breakpoint-md}) {
      font-size: 1rem;
    }
  }

  &__score {
    border-radius: 50%;
    background: $racq-pale-blue;
    border: 1px solid $racq-pale-blue-border;
    min-width: 4.375rem;
    min-height: 4.375rem;
    color: $racq-navy;
  }

  .mobility-club-link {
    text-decoration: none;
    font-size: 0.875rem;

    &.racq-club-review {
      color: $racq-cool-grey;
    }

    @media screen and (min-width: #{$breakpoint-md}) {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.loading * {
  color: transparent;
  background: transparent;
  visibility: hidden;
}
</style>
